import {
  AppBar,
  Box,
  // Button,
  IconButton,
  Skeleton,
  Toolbar,
  Typography,
  Divider
} from "@mui/material";
// import { Divider } from "@zoom/react-ui";
import UserAvatar from "./UserAvatar";
import React from "react";
import { ZOOM_LOGO } from "../utils/constants";
import './style.css'


const Appbar = ({
  userName,
  isUserInfoLoading,
  setUserInfoModalOpen,
  appName,
}) => (
  <Box className="appbar_container">
    <AppBar
      className="dashboard-title-bar"
      position="fixed"
      sx={{ zIndex: 1202, height: "58px", background: "#fff" }}
    >
      <Toolbar>
        <img
          src={ZOOM_LOGO}
          alt="Zoom Logo"
          className="nav-logo"
          onClick={() => (window.location = "/")}
        />
        <Divider orientation="vertical" className="nav-separator" style={{ height: '60%', margin: '0px 8px' }} />
        <Typography
          variant="h6"
          noWrap
          component="div"
          className="operations-3d-title"
        >
          {appName}
        </Typography>
        <Box sx={{ ml: "auto" }}></Box>
        {!isUserInfoLoading ? (
          <IconButton
            onClick={() => setUserInfoModalOpen((old) => !old)}
            style={{ textTransform: "none" }}
          >
            <UserAvatar name={userName || "Guest"} />
          </IconButton>
        ) : (
          <Skeleton
            animation="wave"
            width={400}
            style={{ padding: "5px", margin: "0 15px 0 0" }}
          />
        )}
      </Toolbar>
    </AppBar>
  </Box>
);

export default Appbar;
